export interface ShouldAcceptSuggestedPriceImportColumnParams {
  isPriceUpdate: boolean;
  suggestedPriceEnhancementPhase: number;
  useSuggestedPricing: boolean;
}

// Single source of truth for when the XLSX import accepts a Suggested Price column.
//
// This is deliberately WEAKER than shouldShowSuggestedPricePerUnitColumn: it omits the
// showSuggestedPricePerUnitColumn check. That toggle only controls whether the column is
// *rendered* in the buyer grid, so turning it off does not mean the buyer stopped wanting to
// bulk-set the value — a sheet that carries the column is still processed. The other three
// conditions are shared with the display/export gate and must hold:
//   - suggestedPriceEnhancementPhase >= 1 (LaunchDarkly phased flag)
//   - useSuggestedPricing (drawer kill switch, wired from !request.anchor_pricing_disabled) —
//     off means the event does not use suggested pricing at all, so the column is ignored
//   - !isPriceUpdate (price-update events collapse to the single Current Agreed Price column,
//     and getExportColumnNames never emits Suggested Price for them)
export const shouldAcceptSuggestedPriceImportColumn = ({
  isPriceUpdate,
  suggestedPriceEnhancementPhase,
  useSuggestedPricing,
}: ShouldAcceptSuggestedPriceImportColumnParams): boolean => (
  suggestedPriceEnhancementPhase >= 1
    && useSuggestedPricing
    && !isPriceUpdate
);
